export default {
    cta: "Zeptejte se An<br/> Poradce",
    ordered: "Objednáno dne {date}"
}